import mapCartItem from '../shared/map-cart-item'
import buildCoupon from '../shared/build-coupon'

export default function(config, payload, cartContext, analytics) {
    if (!payload.payment || !cartContext) {
        return
    }

    analytics.track('add_payment_info', {
        ecommerce: {
            currency: 'USD',
            value: cartContext.total,
            coupon: buildCoupon(cartContext.discounts),
            payment_type: 'credit_card',
            items: Object.values(cartContext.items).map(mapCartItem),
        },
    })
}
